import React, { useState, useEffect } from 'react';
import { Fade, useTheme } from '@mui/material';

interface Props {
  children: React.ReactElement;
}

const FadeMount = ({ children }: Props) => {
  const [fadeIn, setFadeIn] = useState(false);
  const theme = useTheme();

  const timeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  useEffect(() => {
    setFadeIn(true);

    return () => setFadeIn(false);
  }, []); //eslint-disable-line

  return (
    <Fade in={fadeIn} timeout={timeout}>
      {children}
    </Fade>
  );
};

export default FadeMount;
